import { validateProperty } from 'ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty';
export const validateUniqueId = uniqueId => {
  const isValidProperty = typeof uniqueId === 'string' && uniqueId.length > 0;
  return validateProperty(isValidProperty, `expected uniqueId to be a non-empty string but got ${uniqueId}`, 'uniqueId');
};